import {FC, PropsWithChildren, useEffect} from 'react';
import {observer} from 'mobx-react-lite';
import {useService} from '@yosmanyga/di';
import {UnnormalizedProps} from '@yosmanyga/core-style';
import {Button, Icon, Text, useIcons} from "@yosmanyga/rich-ui";
import {ProfileController} from '@yosmanyga/fortaleza-core';

const PaymentSuccess = observer(({
    templates,
    onContinue,
}: PaymentSuccessProps) => {
    const icons = useIcons();

    const controller = useService(ProfileController, []);

    useEffect(() => {
        (async () => {
            await controller.load();
        })();
    }, []);

    if (!controller.loaded) {
        return <templates.layout/>;
    }

    return <templates.layout>
        <Text>
            Thank you for your purchase!
        </Text>
        <Text
            margin={{
                top: 4
            }}
        >
            Now you have the Premium version
        </Text>
        <Button
            onClick={onContinue}
            margin={{
                top: 4
            }}
        >
            <Text>Continue playing</Text>
            <Icon
                component={icons.actions.play}
                size='xs'
            />
        </Button>
    </templates.layout>
});

type PaymentSuccessProps = {
    templates: {
        layout: FC<PropsWithChildren<UnnormalizedProps>>;
    },
    onContinue: () => void;
};

export {PaymentSuccess};
